const GENERIC_EVENT_NAME = 'analytics_event';
const YOUNG_DRIVER_AGE_THRESHOLD = 25;
const SENIOR_DRIVER_AGE_THRESHOLD = 65;

export {
  GENERIC_EVENT_NAME,
  YOUNG_DRIVER_AGE_THRESHOLD,
  SENIOR_DRIVER_AGE_THRESHOLD,
};
